export default "__VITE_ASSET__DJoa2oMb__"